import createReducer from "./createReducer";
import { addFiltering } from "./common/Filtering";
import { addColumnFilters } from "./common/ColumnFilters";
import { SUPPRESS_SUCCESS_GROWL, SUPPRESS_ERROR_GROWL, DATE_AND_TIME_FORMAT } from "utils/constants";
import { DTREES_ACTIONS } from "./actions/DTrees";
import moment from "moment";


let initialState = {
	isLoaded: true,
	hasErrorLoading: false,
	items: [],
	modalProps:{
		isLoaded: false,
	},
	isAssigning:false,
};

export function loadDTrees(libraryId, creativeIds = []){
	return (dispatch, getState) => {
		let creatives = creativeIds.map((id) => { return { id: parseInt(id) }; });
		let state = getState();
		let { filterInfo } = state.dtrees;
		let { rpp, page, sort } = filterInfo;
		const [sortCol, sortDir] = sort.split(":");
		let ajaxData = {};
		if(sortCol && sortDir){
			ajaxData = { creatives, rpp, page, sortBy:sortCol, sortOrder:sortDir.toLowerCase() };
		} else {
			ajaxData = { creatives, rpp, page  };
		}


		return dispatch({
			type: DTREES_ACTIONS.LOAD_DTREES_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				gateway: "dt",
				url: `ui/creative-libraries/${libraryId}/version-dtrees`,
				method: "post",
				version: 2,
				data: ajaxData,
				success: DTREES_ACTIONS.LOAD_DTREES_SUCCESS,
				error: DTREES_ACTIONS.LOAD_DTREES_ERROR,
			},
		});
	};
}

export function viewDTreeModal(modalAction, modalOpts){
	return ((dispatch) => {
		dispatch({
			type: DTREES_ACTIONS.VIEW_DTREE_MODAL,
			payload: { modalAction, ...modalOpts },
		});
	});
}

export function unassignDTree(libraryId, creativeId, versionId){
	return ((dispatch) => {
		return dispatch({
			type: DTREES_ACTIONS.UNASSIGN_DTREES_AJAX,
			AJAX: {
				url: `creative-libraries/${libraryId}/unassign-decision-tree`,
				method: "post",
				data: [{
					creativeId,
					instantAdId:versionId,
				}],
				success: DTREES_ACTIONS.UNASSIGN_DTREES_AJAX_SUCCESS,
				error: DTREES_ACTIONS.UNASSIGN_DTREES_AJAX_ERROR,
			},
		});
	});
}

export function assignDTree(libraryId, creativeIds, dtreeId){
	// The assign action, for now, only assigns the dtree to one creativeId,
	// but the endpoint can be used for assigning the same dtree to multiple
	// creatveIds.  An array named 'creatives' of the form [{id:creativeId}]
	// allows for single and bulk assignment.

	let creatives = creativeIds.map((creative)=>{
		return {
			id:parseInt(creative),
		};
	});

	return ((dispatch) => {
		return dispatch({
			type: DTREES_ACTIONS.ASSIGN_DTREES_AJAX,
			AJAX: {
				gateway: "dt",
				url: `ui/creative-libraries/${libraryId}/assign-decision-tree`,
				method: "post",
				data: {
					decisionTree:{ id:dtreeId },
					creatives,
				},
				success: DTREES_ACTIONS.ASSIGN_DTREES_AJAX_SUCCESS,
				error: DTREES_ACTIONS.ASSIGN_DTREES_AJAX_ERROR,
			},
		});
	}
	);
}

export function clearModal() {
	return ((dispatch) => {
		dispatch({
			type: DTREES_ACTIONS.CLEAR_DTREE_MODAL,
		});
	});
}

export function duplicateDTree(newDTreeName, dtreeId){
	return (dispatch) => {
		return dispatch({
			type: DTREES_ACTIONS.DUPLICATE_DTREE_AJAX,
			meta: SUPPRESS_ERROR_GROWL,
			AJAX: {
				gateway:"dt",
				url: `ui/dtree/${dtreeId}/duplicate`,
				method: 'post',
				success: DTREES_ACTIONS.DUPLICATE_DTREE_SUCCESS,
				error: DTREES_ACTIONS.DUPLICATE_DTREE_ERROR,
				data:{ name:newDTreeName },
			},
		});
	};
}

export function checkDTreeNameAvailable(libraryId, dtreeName){
	return (dispatch)=>{
		return dispatch({
			type: DTREES_ACTIONS.FETCH_DTREE_NAME,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				gateway: 'dt',
				url: 'ui/dtree-name-check',
				method: 'post',
				success: DTREES_ACTIONS.FETCH_DTREE_NAME_SUCCESS,
				error: DTREES_ACTIONS.FETCH_DTREE_NAME_ERROR,
				data: {
					creativeLibrary: {
						id: libraryId,
					},
					name: dtreeName,
					treeType: "version",
				},
			},
		}).then((response) => {
			if(response?.success){
				//The successful response.data is {}.
				return { success:true, data:response.data };
			} else {
				return {
					success:false,
					description: response?.payload?.errorObj?.description,
				};
			}
		});
	};
}

export function getLinkedCreatives(libraryId, dtreeId){
	return (dispatch) => {
		return dispatch({
			type: DTREES_ACTIONS.FETCH_DTREE_LINKED_CREATIVES,
			meta:SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `creative-libraries/${libraryId}/decision-trees/${dtreeId}/creatives`,
				success: DTREES_ACTIONS.FETCH_DTREE_LINKED_CREATIVES_SUCCESS,
				error: DTREES_ACTIONS.FETCH_DTREE_LINKED_CREATIVES_ERROR,
			},
		}).then((response) => {
			if(response?.success){
				let { items } =  response.payload?.data;
				if(items?.length){
					return items.map((item) => {
						return {
							name:item.name,
							id:item.id,
							approval:item.approval,
						};
					});
				}
			}
		});
	};
}

const actionCreators = {
	viewDTreeModal,
	clearModal,
	loadDTrees,
	duplicateDTree,
	checkDTreeNameAvailable,
	getLinkedCreatives,
	unassignDTree,
	assignDTree,
};

export const handlers = {
	[DTREES_ACTIONS.VIEW_DTREE_MODAL]               : initModal,
	[DTREES_ACTIONS.CLEAR_DTREE_MODAL]              : clearedModal,
	[DTREES_ACTIONS.LOAD_DTREES_AJAX]               : isLoadingDTrees,
	[DTREES_ACTIONS.LOAD_DTREES_SUCCESS]            : initDTrees,
	[DTREES_ACTIONS.LOAD_DTREES_ERROR]              : loadDTreesError,

	[DTREES_ACTIONS.DUPLICATE_DTREE_AJAX]           : initDuplicateDTree,
	[DTREES_ACTIONS.DUPLICATE_DTREE_SUCCESS]        : duplicateDTreeSuccess,
	[DTREES_ACTIONS.DUPLICATE_DTREE_ERROR]          : duplicateDTreeError,
	[DTREES_ACTIONS.UNASSIGN_DTREES_AJAX]           : initUnassignment,
	[DTREES_ACTIONS.UNASSIGN_DTREES_AJAX_SUCCESS]   : unassignSuccess,
	[DTREES_ACTIONS.UNASSIGN_DTREES_AJAX_ERROR]     : unassignError,
	[DTREES_ACTIONS.ASSIGN_DTREES_AJAX]             : initAssignment,
	[DTREES_ACTIONS.ASSIGN_DTREES_AJAX_SUCCESS]     : assignmentSuccess,
	[DTREES_ACTIONS.ASSIGN_DTREES_AJAX_ERROR]       : assignmentError,
};

let reducerConfig = {
	typeRoot: "DTREES",
	initialState,
	actionTypes: DTREES_ACTIONS,
	actionCreators,
	handlers,
};

reducerConfig = addFiltering(reducerConfig, { sort:"id:asc" });
reducerConfig = addColumnFilters(reducerConfig, {
	approval: {
		name: "approval",
		type: "Checkbox",
		displayName: "Status",
		dictionaryName: "approval",
	},
});

function isLoadingDTrees(state, action){
	return {
		...state,
		isLoaded: false,
	};
}

function initDTrees(state, action){
	let { data } =  action.payload
		, { items, totalPages, totalItems } = data;
	return {
		...state,
		isLoaded: true,
		hasErrorLoading: false,
		filterInfo: {
			...state.filterInfo,
			totalPages,
			totalItems,
		},
		items,
	};
}

function loadDTreesError(state, action){
	return {
		...state,
		isLoaded: true,
		hasErrorLoading: true,
	};
}

function initModal(state, action) {
	return {
		...state,
		modalProps:{
			 ...action.payload
			, isLoaded:true,
		},
	};
}

function clearedModal(state, action) {
	return {
		...state,
		modalProps:{},
		isLoaded:false,
		items: [],
	};
}

function initDuplicateDTree(state, action){
	return{
		...state,
	};
}

function duplicateDTreeSuccess(state, action){
	let { data } = action.payload
		, { items } = state
		, newItems = [{ ...data, lastUpdated:moment().format(DATE_AND_TIME_FORMAT) }, ...items];

	return {
		...state,
		items:newItems,
		isLoaded: true,
		hasErrorLoading: false,
	};
}

function duplicateDTreeError(state, action){
	return {
		...state,
		isLoaded: true,
		hasErrorLoading: true,
	};
}

function initUnassignment(state, action){
	return {
		...state,
		isAssigning:true,
	};
}

function unassignSuccess(state, action){
	return {
		...state,
		isAssigning:false,
	};
}

function unassignError(state, action){
	return {
		...state,
		isAssigning:false,
	};
}

function initAssignment(state, action){
	return {
		...state,
		isAssigning:true,
	};
}

function assignmentSuccess(state, action){
	return {
		...state,
		isAssigning:false,
	};
}

function assignmentError(state, action){
	return {
		...state,
		isAssigning:false,
	};
}

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const DTrees = reducerConfig.actionCreators;
